import acceptanceInfoIconHtml from './shiftAcceptanceInfoIconComponent.html';

export default {
  templateUrl: acceptanceInfoIconHtml,
  controllerAs: 'ctrl',
  bindings: {
    tooltipText: '<',
  },
};
